<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Clientes Deudores</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Clientes Deudores</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-xl-10 col-lg-12">
                <div class="card card-dark">
                    <div class="card-header">
                        <h2 class="card-title">Deudores</h2>
                        <div class="card-tools">
                            <div class="input-group input-group-sm" style="width: 200px;">
                                <input class="form-control form-control-lg" [formControl]="searchForm.get('search')"
                                    id="inputSearch" name="inputSearch" type="text" placeholder="Buscar"
                                    aria-label="Search" autocomplete="off">
                                <div class="input-group-append">
                                    <span class="input-group-text bg-info"><i class="fas fa-search"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-hover table-head-fixed text-nowrap" data-page-length="10"
                            *ngIf="clientes">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Cliente</th>
                                    <th style="width: 250px;">Teléfono</th>
                                    <th style="width: 250px;">Deuda</th>
                                    <th style="width: 250px;" class="text-center">Acción</th>
                                </tr>
                            </thead>
                            <tbody
                                *ngFor="let item of clientes | pagination: {itemsPerPage: itemsPerPage, currentPage:page} | searchClienteDeudores:searchForm.get('search').value; let i=index">
                                <tr>
                                    <td>
                                        <button class="btn btn-link" (click)="openDetail(i,item.id_cliente)">
                                            <i class="fas fa-chevron-right" *ngIf="!this.isExpanded[i]"></i>
                                            <i class="fas fa-chevron-down" *ngIf="this.isExpanded[i]"></i></button>
                                    </td>
                                    <td>{{item.nombre_completo}}</td>
                                    <td style="width: 250px;">{{Func.formatTelefono(item.telefono)}}</td>
                                    <td style="width: 250px;">{{Func.currencyPeso(item.saldo)}}</td>
                                    <td style="width: 250px;" class="text-center">
                                        <button type="button" (click)="goDetalleCliente(item.id_cliente)" name="seemore"
                                            class="btn btn-outline-dark">
                                            <i class="fas fa-ellipsis-h"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="isExpanded[i]">
                                    <td colspan="5" class="p-0">
                                        <app-lista-pedidos (updateData)="getDataDeuda(item.id_cliente)"
                                            (updateDataMedioPago)="getDataDeudaUpdate($event)" [rows]="deuda"
                                            [tempRows]="deuda" [mini]="false" [showHeader]="false" [showFooter]="false"
                                            [sortByKey]="'id_pedido'" [reverseSort]="false" [isLoading]="isLoading"
                                            [onlyMedioPago]="true"></app-lista-pedidos>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <app-footer-pagination *ngIf="clientes" [totalItems]="clientes.length" [itemsPerPage]="itemsPerPage"
                        [page]="page" (onPageChanged)="pageChanged($event)"></app-footer-pagination>
                </div>
            </div>
        </div>
    </div>
</section>